const parseAmount = (value) => {
  const amount = Number.parseFloat(value);
  return Number.isFinite(amount) ? amount : 0;
};

export const evaluateLedgerEntry = (memo, lines) => {
  const cleanMemo = (memo || '').trim();
  const normalized = (lines || []).map((line) => ({
    account_code: line.account_code || '',
    debit_usd: parseAmount(line.debit_usd),
    credit_usd: parseAmount(line.credit_usd),
    memo: (line.memo || '').trim(),
  }));
  const hasNegative = normalized.some((line) => line.debit_usd < 0 || line.credit_usd < 0);
  const postingLines = normalized.filter((line) => line.debit_usd > 0 || line.credit_usd > 0);
  const debitTotal = postingLines.reduce((sum, line) => sum + line.debit_usd, 0);
  const creditTotal = postingLines.reduce((sum, line) => sum + line.credit_usd, 0);

  let message = 'Ready to post this balanced entry.';
  if (cleanMemo.length < 3) message = 'Add a memo of at least 3 characters.';
  else if (hasNegative) message = 'Debit and credit amounts cannot be negative.';
  else if (postingLines.length < 2) message = 'Enter amounts on at least two ledger lines.';
  else if (postingLines.some((line) => !line.account_code)) message = 'Select an account for every line with an amount.';
  else if (debitTotal <= 0 || creditTotal <= 0) message = 'The entry needs at least one debit and one credit.';
  else if (Math.abs(debitTotal - creditTotal) >= 0.005) message = 'Debits and credits must balance before posting.';

  return {
    valid: message.startsWith('Ready'),
    message,
    cleanMemo,
    postingLines,
    debitTotal,
    creditTotal,
    imbalance: Math.round((debitTotal - creditTotal) * 100) / 100,
    balancingSide: debitTotal > creditTotal ? 'credit' : 'debit',
    balancingAmount: Math.round(Math.abs(debitTotal - creditTotal) * 100) / 100,
  };
};